// hooks & stores
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'

export default function useOfficer() {
    const manageProjectStore = useManageProjectStore()
    return {
        projectData: manageProjectStore.projectData,
    }
}
